import { Box, Theme, useMediaQuery } from '@mui/material'
import { useRef } from 'react'
import TypesOfTrusts from './TypesOfTrusts'
import WhyScs from './WhyScs'
import StatesWeService from './StatesWeService'
import Forms from './Forms'
// import Contact from './Contact'
import Benefits from './Benefits'
import HeroSection from './Hero'
import SEO from '../layout/SEO'

export type Link = {
    path: string
    label: string
    componentRef: React.MutableRefObject<HTMLDivElement | null>
}

const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://scstrusts.org/#organization',
    name: 'SCS Trust Services',
    url: 'https://scstrusts.org/',
    legalName: 'Senior Community Services, Inc.',
    alternateName: ['SCS Pooled Trust'],
    logo: {
        '@type': 'ImageObject',
        url: 'https://scstrusts.org/logo.png'
    },
    address: {
        '@type': 'PostalAddress',
        streetAddress: '100 Boulevard of the Americas',
        addressLocality: 'Lakewood',
        addressRegion: 'NJ',
        postalCode: '08701',
        addressCountry: 'US'
    },
    contactPoint: [
        { '@type': 'ContactPoint', contactType: 'customer service', telephone: '+1-800-540-6732', areaServed: 'US' },
        { '@type': 'ContactPoint', contactType: 'customer service', telephone: '+1-718-971-2509', areaServed: 'US' }
    ],
    sameAs: ['https://www.facebook.com/scstrusts/', 'https://www.instagram.com/scstrusts/', 'https://x.com/scspooledtrust']
}

const HomePage = () => {
    const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
    const whyScsRef = useRef<HTMLDivElement | null>(null)
    const statesWeServiceRef = useRef<HTMLDivElement | null>(null)
    const contactRef = useRef<HTMLDivElement | null>(null)
    const formsRef = useRef<HTMLDivElement | null>(null)
    const typesOfTrustsRef = useRef<HTMLDivElement | null>(null)
    const benefitsRef = useRef<HTMLDivElement | null>(null)

    const links = {
        typesOfTrusts: {
            label: 'Types of Trusts',
            path: '#types-of-trusts',
            componentRef: typesOfTrustsRef
        },
        whyScs: {
            label: 'Why SCS',
            path: '#why-scs',
            componentRef: whyScsRef
        },
        benefits: {
            label: 'Benefits',
            path: '#benefits',
            componentRef: benefitsRef
        },
        statesWeService: {
            label: 'States We Service',
            path: '#states-we-service',
            componentRef: statesWeServiceRef
        },
        forms: {
            label: 'Forms',
            path: '#forms',
            componentRef: formsRef
        },
        contact: {
            label: 'Contact',
            path: '#contact',
            componentRef: contactRef
        }
    } as const

    return (
        <>
            <SEO
                title="SCS Trust Services"
                description="Professional trust administration services. Protect benefits, simplify management, and get support nationwide."
                path="/"
                jsonLd={orgSchema}
            />
            <Box>
                <Box
                    sx={{
                        background: 'linear-gradient(to right bottom, #084E70, #498ABD, #965CAA, #F9E3FF, #FFFFFF)',
                        paddingTop: { xs: '110px', md: '162px' },
                    }}
                    className="h-[852px] tbmd:h-[1113px]"
                >
                    {!mdDown && (
                        <Box
                            sx={{
                                background: 'linear-gradient(0.40turn, transparent 15%, transparent 20%, #ffffff33 25%, transparent 30%, transparent)',
                                top: 0,
                            }}
                            className="animate__animated animate__shakeX animate__infinite absolute h-[852px] w-full overflow-x-hidden [--animate-duration:10s] tbmd:h-[1113px]"
                        />
                    )}
                    {/* <NavBar /> */}
                    <HeroSection typesOfTrustRef={links.typesOfTrusts.componentRef} />
                </Box>
                <TypesOfTrusts link={links.typesOfTrusts} />
                <WhyScs link={links.whyScs} />
                <Box className="bg-[#E4F2F7] bg-opacity-40 ">
                    <Benefits link={links.benefits} />
                    <StatesWeService link={links.statesWeService} />
                    <Forms link={links.forms} />
                </Box>
                {/* <Contact link={links.contact} /> */}
            </Box>
        </>
    )
}

export default HomePage
